import React from 'react';
import styled from 'styled-components';
import { space, border, layout, color, typography } from 'styled-system';

import { colors } from '@styles/theme';

export const CIRCLE_DIAMETER = '36px';

const Circle = styled('div')(
  {
    fontSize: 16,
    color: colors.grayscale.black,
    borderRadius: '9999px',
    height: 36,
    width: 36
  },
  {
    WebkitFontSmoothing: 'antialiased',
    borderWidth: '1px',
    borderStyle: 'solid',
    display: 'inline-block',
    textAlign: 'center',
    lineHeight: '32px',
    textTransform: 'uppercase',
    verticalAlign: 'middle'
  },
  space,
  border,
  layout,
  color,
  typography
);

Circle.displayName = 'Circle';

export default ({ color, ...props }) => (
  <Circle
    {...props}
    css={`
      color: ${color || 'inherit'};
      fill: ${color || 'inherit'};
      svg {
        height: 18px;
        width: 18px;
        margin-top: 5px;
      }
    `}
  />
);
